type Constructor<T = HTMLElement> = new (...args: any[]) => T;

const warnedTags = new Set<string>();

/**
 * Wrap a custom element class in a deprecated alias constructor that warns once
 * per page when the deprecated tag is first connected.
 */
export function DeprecatedEl<TBase extends Constructor>(
  Base: TBase,
  deprecatedTag: string,
  replacementTag: string,
  warning?: string,
): TBase {
  return class DeprecatedElement extends Base {
    connectedCallback(...args: any[]): void {
      if (!warnedTags.has(deprecatedTag)) {
        warnedTags.add(deprecatedTag);
        console.warn(warning ?? `<${deprecatedTag}> is deprecated — use <${replacementTag}> instead.`);
      }
      super.connectedCallback?.(...args);
    }
  } as TBase;
}
